module.exports = __webpack_public_path__ + "ba63ac85e7ecb370e0d4e639c618692b.jpg";